/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiSocietaSocietaidSmtpConfigurationPathParamsSchema = z.object(
  {
    societaId: z.coerce.number().int(),
  },
);

/**
 * @description OK
 */
export const putApiSocietaSocietaidSmtpConfiguration200Schema = z.object({
  societaId: z.coerce.number().int(),
  societaName: z.coerce.string(),
  isConfigured: z.boolean(),
  host: z.coerce.string().nullable().nullish(),
  port: z.coerce.number().int().nullable().nullish(),
  authEnabled: z.boolean().nullable().nullish(),
  username: z.coerce.string().nullable().nullish(),
  senderEmail: z.coerce.string().nullable().nullish(),
  senderName: z.coerce.string().nullable().nullish(),
  socketSecurity: z
    .enum(['auto', 'startTls', 'sslOnConnect', 'none'])
    .nullable()
    .nullish(),
  hasPassword: z.boolean(),
});

export const putApiSocietaSocietaidSmtpConfigurationMutationRequestSchema =
  z.object({
    host: z.coerce.string(),
    port: z.coerce.number().int().optional(),
    authEnabled: z.boolean().optional(),
    username: z.coerce.string().nullable().nullish(),
    password: z.coerce.string().nullable().nullish(),
    clearPassword: z.boolean().optional(),
    senderEmail: z.coerce.string(),
    senderName: z.coerce.string().nullable().nullish(),
    socketSecurity: z
      .enum(['auto', 'startTls', 'sslOnConnect', 'none'])
      .optional(),
  });

export const putApiSocietaSocietaidSmtpConfigurationMutationResponseSchema =
  z.lazy(() => putApiSocietaSocietaidSmtpConfiguration200Schema);
